
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#D6DBEA","stroke-width":"1.808","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M53.496 31.411H11.904l9.946-16.275 9.946 16.275m-2.713-16.275l9.946 16.275m-2.712-16.275l9.946 16.275m-14.467 5.425v-5.425m-19.892 0v5.425m9.946-21.7h22.604m-19.289 5.425h22.906m-19.59 5.425h23.207M30.892 51.302h21.7a.903.903 0 00.904-.903v-7.234a.904.904 0 00-.904-.904H39.029m0-10.85v10.85m7.234-10.85v10.85"}}),_c('path',{attrs:{"d":"M11.904 47.686h19.892v3.617H11.904zm3.617-3.617h19.892v3.617H15.521zm-3.617-3.616h19.892v3.616H11.904z"}})])])
          )
        }
      }
    